import { createServerFn } from "@tanstack/react-start";
import { loadCheapestInsights } from "./cheapestPrices.server";

/** Publik läsning av spotprisinsikter (billigaste tid idag/imorgon/historiskt). */
export const getCheapestInsights = createServerFn({ method: "GET" }).handler(async () => {
  try {
    return await loadCheapestInsights();
  } catch {
    return null;
  }
});
